import request from '../request';

/**
 * 专家列表
 */
export function expertList(obj){
    return request({
        url:'/zs/farmingExpert/queryFarmingExpertPage',
        method:'get',
        params:obj
    })
}

/**
 * 专家详情
 */
export function expertInfo(obj){
    return request({
        url:'/zs/farmingExpert/queryFarmingExpertInfo',
        method:'get',
        params:obj
    })
}


// WEBPACK FOOTER //
// ./src/api/http/expert.js